import React from "react";
import i18next from "i18next";

export const ITEquipmentControl = (props) => {
    return (<div>
        <label>
            <a href="#" rel="noopener noreferrer"
               onClick={(event) => {
                   event && event.preventDefault();
                   props.onClick && props.onClick();
               }}
               className="mr-2">{props.readOnly ? i18next.t("View") : i18next.t("Change")}</a>
        </label>
    </div>);
}